import {
  PageConfig,
  PageConfigSchemaVersion,
} from "../../config/pageConfig.types";
import { DefaultFormId } from "../../config/resolveView";
import { fullWidth, halfWidth } from "../../blocks/layout/columnSpans";
import { dataModelTypeOptions } from "./dataModelValidators";

/**
 * Data Model as page config. The value is checked against the chosen type before a
 * save, as the warehouse checks it again when it arrives.
 */
export const dataModelPageConfig: PageConfig = {
  schemaVersion: PageConfigSchemaVersion,
  entityName: "dwdatamodel",
  viewId: DefaultFormId,
  pageType: "record",
  rows: [
    {
      id: "row-main",
      columns: [
        {
          id: "column-primary",
          span: { desktop: 9, tablet: 9, mobile: 12 },
          blocks: [
            {
              kind: "section",
              id: "section-data-model",
              // The page bar already names the record.
              title: "",
              fields: [
                {
                  id: "field-name",
                  type: "text",
                  name: "name",
                  label: "Name",
                  required: true,
                  isNameField: true,
                  span: halfWidth,
                },
                {
                  id: "field-datavalue",
                  type: "text",
                  name: "datavalue",
                  label: "Value",
                  required: true,
                  validatorKey: "dataModelValue",
                  span: halfWidth,
                },
                {
                  id: "field-datadescription",
                  type: "longtext",
                  name: "datadescription",
                  label: "Description",
                  span: fullWidth,
                },
              ],
            },
          ],
        },
        {
          id: "column-secondary",
          span: { desktop: 3, tablet: 3, mobile: 12 },
          card: true,
          fillHeight: true,
          blocks: [
            {
              kind: "section",
              id: "section-classification",
              title: "Classification",
              fields: [
                {
                  id: "field-datamodelcategory",
                  type: "text",
                  name: "datamodelcategory",
                  label: "Category",
                  required: true,
                  span: fullWidth,
                },
                {
                  id: "field-type",
                  type: "picklist",
                  name: "type",
                  label: "Type",
                  required: true,
                  options: dataModelTypeOptions,
                  span: fullWidth,
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
